import { moduloGuard } from '@intelishs-group/session-core';
import { Routes } from '@angular/router';
import { DashboardPage } from './pages/dashboard/dashboard.page';

export const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardPage,
  },
  {
    path: 'herramientas',
    canActivate: [moduloGuard('herramientas')],
    loadComponent: () =>
      import('./pages/herramientas/herramientas.page').then((m) => m.HerramientasPage),
  },
  // Cada herramienta es un modulo lazy independiente. Al agregar una nueva:
  // 1) crear la carpeta en pages/herramientas/<id>/
  // 2) registrar la ruta aqui
  // 3) darla de alta en pages/herramientas/herramientas.registry.ts
  {
    path: 'herramientas/xlsx-a-csv',
    canActivate: [moduloGuard('herramientas')],
    loadComponent: () =>
      import('./pages/herramientas/xlsx-a-csv/xlsx-a-csv.page').then((m) => m.XlsxACsvPage),
  },
  {
    path: '**',
    redirectTo: 'herramientas',
  },
];
